import React, { memo, useEffect, useState } from 'react';
import cls from './Diagram.module.css';
import classNames from 'classnames';
import { DaysMode } from './DaysMode/DaysMode';
import { WeeksMode } from './WeeksMode/WeeksMode';
import { MonthMode } from './MonthMode/MonthMode';
import { Arrow } from '../../../UI/Arrow/Arrow';
import { useSelector } from 'react-redux';
import { stageSelector } from '../../../../store/reducers/stageSlice/stageSlice';
import { Connections } from '../../../UI/Connections/Connections';

export const Diagram = memo(({ stages, diagramRef, diagramPosition, scrollDiagram }) => {
    const { activeTab, isNeedUpdateStart } = useSelector((state) => state.gantReducer);

    const allStages = useSelector(stageSelector.selectAll);

    const [scrollLeft, setScrollLeft] = useState(0);
    const { isConnection } = useSelector((state) => state.connectionReducer);
    const nonNullStages = allStages.filter((stage) => stage.planned.days_count);
    const [diagramWidth, setDiagramWidth] = useState(0);
    const [diagramOffsetLeft, setDiagramOffsetLeft] = useState(0);
    const isNullStages = !nonNullStages.length;

    useEffect(() => {
        if (diagramRef !== null) {
            const { width, left } = diagramRef.current.getBoundingClientRect();

            setDiagramWidth(width);
            let element = diagramRef.current?.querySelector('[data-date-now="true"]');

            scrollDiagram(element);

            setDiagramOffsetLeft(diagramRef.current.scrollLeft);
        }
    }, [diagramRef, activeTab, isNeedUpdateStart]);

    useEffect(() => {
        const handleScroll = (event) => {
            setScrollLeft(event.currentTarget.scrollLeft);
        };

        const currentDiagram = diagramRef.current;
        if (currentDiagram) {
            currentDiagram.addEventListener('scroll', (event) => handleScroll(event));
        }

        return () => {
            if (currentDiagram) {
                currentDiagram.removeEventListener('scroll', (event) => handleScroll(event));
            }
        };
    }, []);

    const modeMapping = {
        day: <DaysMode stages={stages} isBlur={isNullStages && !isPlanFact} classes={cls.blurEl} />,
        week: (
            <WeeksMode stages={stages} isBlur={isNullStages && !isPlanFact} classes={cls.blurEl} />
        ),
        month: (
            <MonthMode stages={stages} isBlur={isNullStages && !isPlanFact} classes={cls.blurEl} />
        ),
    };

    return (
        <div
            className={classNames(cls.Diagram)}
            ref={diagramRef}
            style={{ overflow: isNullStages ? 'hidden' : 'auto' }}
        >
            {isNullStages && !isPlanFact && (
                <div
                    style={{
                        left: `calc(${diagramOffsetLeft}px + ${diagramWidth / 2}px)`,
                    }}
                    className={cls.zag}
                >
                    <p>{i18next.t('Diagram.return.Diagram.zag.part1')}</p>
                    <p>{i18next.t('Diagram.return.Diagram.zag.part2')}</p>
                </div>
            )}
            {isConnection && <Arrow position={diagramPosition} scrollLeft={scrollLeft} />}
            {modeMapping[activeTab]}
        </div>
    );
});
